
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/panamax-infotech",
      function () {
        return require("private-next-pages/case-study/panamax-infotech.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/panamax-infotech"])
      });
    }
  